<template lang="html">
  <nav class="">
    <div v-for="link in site.menu" :key="link.id">
      <a :href="'#' + link.id" class="nul big mbig">
        {{ link.title }}
      </a>
      <div class="subpages small">
        <a :href="'#' + sub.id" v-for="(sub, index) in link.subpages" :key="index">{{ sub.title }}</a>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["site"]),
  methods: {
    goTo(uid) {
      // scroll to section
      this.$scrollTo("#" + uid, 1000);
      // change url
      this.$router.push({ path: "/" + this.$i18n.locale + "/" + uid });
    }
  }
};
</script>

<style lang="scss" scoped>
nav {
  z-index:999;
  background:var(--bg);
  width:100%;
  display: flex;
  flex-direction: column;
  .subpages {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // padding-left:calc(2 * var(--lh));
  }
  .subpages a {
    // display:block;
    // padding-left:calc(2 * var(--lh));
  }
}
</style>
